import { Component, Mixins } from 'vue-property-decorator';
import HybridMixin from '@rogues/shared/mixins/hybrid';
import CoreMixin from '@nodes/mixins/Core';
import YAddressForm from '@rogues/ProfileAddressEditor/blocks/AddressForm/index.vue';
import Props from './props';

@Component({
    components: {
        YAddressForm,
    },
})

/**
 * @name ProfileAddressEditor
 */
export default class ProfileAddressEditor extends Mixins(HybridMixin, Props, CoreMixin) {
    address = null;
    divisionConfig = null;
    selected = {};
    model: { [k: string]: any } = {};

    /**
     * Do send Address
     *
     * @returns {*}
     */
    save() {
        this.$wait.start('add-address');
        if (this.address) {
            this.model.id = this.address.id;
        }

        return this.$services.Person.addressSave(this.model)
            .then(() => {
                this.model = {};
                this.$toast.success(this.$t('profileAddressEditor.forms.success_msg'));
                this.$emit('refresh');
                this.$emit('close');
            })
            .catch((error) => {
                this.handleError(error);
            })
            .finally(() => {
                this.$wait.end('add-address');
            });
    }
}
